module.exports = __webpack_public_path__ + "img/epc2chicun.2a04ff0e.png";